import * as React from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { cn } from '@/lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false)

    if (type === 'password') {
      return (
        <div className="relative">
          <input
            className={cn(
              'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 pr-10 text-base shadow-sm ' +
                'transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium' +
                'file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none' +
                'focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed' +
                'disabled:opacity-50 md:text-sm',
              className
            )}
            ref={ref}
            type={showPassword ? 'text' : 'password'}
            {...props}
          />
          <button
            className="absolute inset-y-0 right-2 flex items-center text-muted-foreground hover:text-foreground"
            onClick={() => setShowPassword((prev) => !prev)}
            tabIndex={-1}
            type="button"
          >
            {showPassword ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
          </button>
        </div>
      )
    }

    // Default input (para todos los demás tipos)
    return (
      <input
        className={cn(
          'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm ' +
            'transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium' +
            'file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none' +
            'focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        ref={ref}
        type={type}
        {...props}
      />
    )
  }
)

Input.displayName = 'Input'

export { Input }
